// extracted by mini-css-extract-plugin
export var root = "hero-container-module--root--3IfMg";
export var contentBox = "hero-container-module--contentBox--IN1KQ";
export var arrowBox = "hero-container-module--arrowBox--2PBOd";
export var arrow = "hero-container-module--arrow--SPd9B";